import { useState, useEffect } from "react";

export const useHeaderScroll = (styleThreshold = 100, scrollThreshold = 300) => {
	const [scrollData, setScrollData] = useState({
		visible: true,
		pastThreshold: false,
		scrollThreshold: false,
		lastScrollY: 0,
	});

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;

			// 1. Check if we are past the initial threshold for adding styles
			const isPastThreshold = currentScrollY > styleThreshold;

			// KPP DO NOT WANT THE HEADER TO HIDE ON SCROLL SO WE DO NOT NEED STEPS 2 & 3
			// 2. Check if we are past the scroll theshold to hide the header
			// const isScrollThreshold = currentScrollY > scrollThreshold;

			// 3. Determine direction (Scrolling up is true, down is false)
			// We always show the header if we're above the threshold
			// const isScrollingUp = currentScrollY < scrollData.lastScrollY;
			// const visible = !isScrollThreshold || isScrollingUp || currentScrollY < 10;

			setScrollData({
				visible: true,
				pastThreshold: isPastThreshold,
				// scrollThreshold: isScrollThreshold,
				scrollThreshold: false,
				lastScrollY: currentScrollY,
			});
		};

		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, [scrollData.lastScrollY, styleThreshold, scrollThreshold]);

	return scrollData;
};
